const TIME_TRACKER_TYPES = {

    GET_TIME_TRACKER_FIRST: "GET_TIME_TRACKER_FIRST",
    GET_TIME_TRACKER_LOADING: "GET_TIME_TRACKER_LOADING",
    GET_TIME_TRACKER_SUCCESS: "GET_TIME_TRACKER_SUCCESS",
    GET_TIME_TRACKER_ERROR: "GET_TIME_TRACKER_ERROR",
    GET_TIME_TRACKER_RESET: "GET_TIME_TRACKER_RESET",

    GET_USER_RECORD: 'GET_USER_RECORD',
    GET_USER_RECORD_LOADING: 'GET_USER_RECORD_LOADING',
    GET_USER_RECORD_SUCCESS: 'GET_USER_RECORD_SUCCESS',
    GET_USER_RECORD_ERROR: 'GET_USER_RECORD_ERROR',
    GET_USER_RECORD_RESET: 'GET_USER_RECORD_RESET',
};

export default TIME_TRACKER_TYPES